import React from 'react';
import {
  DocumentTextIcon,
  ClockIcon,
  CheckCircleIcon,
} from '@heroicons/react/24/outline';

const StatusIcon = ({ status, className = "h-5 w-5" }) => {
  const iconClass = `${className}`;
  
  switch (status) {
    case 'pending':
      return <ClockIcon className={`${iconClass} text-yellow-500`} />;
    case 'completed':
      return <CheckCircleIcon className={`${iconClass} text-green-500`} />;
    default:
      return <DocumentTextIcon className={`${iconClass} text-gray-500`} />;
  }
};

export default StatusIcon;
